module.exports = __webpack_public_path__ + "img/slide_1.5f18a422.webp";